
import firebase from 'firebase/app';
import 'firebase/firestore';

function DeleteScore(docId, isReadOnly, event){
    
        event.preventDefault();
        
        const uid = firebase.auth().currentUser.uid;
        const readPerm = "permissionRead."+ uid;
        const writePerm = "permissionWrite."+ uid;
        // for recycle bin operation.
        const deleteRead = "deleteRead."+ uid;
        const deleteWrite = "deleteWrite." +uid;

        const db = firebase.firestore();
        db.collection("persons").doc(docId).update({
            [readPerm]: firebase.firestore.FieldValue.delete(),
            [writePerm]: firebase.firestore.FieldValue.delete(),
            [deleteRead]: true,
            ...!isReadOnly && {[deleteWrite]: true}, // check if not readonly.
        })
        .then(() => {
            console.log("document moved to recyle.");
        })
        .catch(function(error) {
            console.error("Error recycling document: ", error);
        });
        
    }



    
export default DeleteScore;


// WEBPACK FOOTER //
// ./src/helpers/DeleteScore.js